/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
export type PromiseGetter<ResponseType> = () => Promise<ResponseType>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface RetryOptions<ResponseType = any> {
	retryFunc: PromiseGetter<ResponseType>;
	retryPredicate?: (error: Error) => boolean;
	retryAttempts?: number;
	onRetry?: (error: Error, retryAttempt: number) => void;
}

export const RETRY_ATTEMPTS_LIMIT = 1;

/**
 * @deprecated Use `import { retryOnError } from '@atlassian/relay-fetch/utils/retryOnError'` instead.
 */
export { retryOnError } from './retryOnError';
/**
 * @deprecated Use `import { shouldRetry } from '@atlassian/relay-fetch/utils/shouldRetry'` instead.
 */
export { shouldRetry } from './shouldRetry';
/**
 * @deprecated Use `import { getRetryAttemptsForQuery } from '@atlassian/relay-fetch/utils/getRetryAttemptsForQuery'` instead.
 */
export { getRetryAttemptsForQuery } from './getRetryAttemptsForQuery';
